import { IsNotEmpty, ValidateIf } from 'class-validator';
import createCollectionResource from 'src/actions/shared/createResource';
import VoiceConfiguration from 'src/models/Channels/VoiceConfiguration';

import * as sharedTypes from 'src/actions/shared/sharedTypes';
import validateType, { translateErrors } from 'src/adapters/validateType';
import { DomainError } from '@ad-scripts/application/lib/error';

const voiceConfigurationResource = createCollectionResource<VoiceConfiguration>({
  name: 'voiceConfiguration',
  endpoint: 'v1/orgs/:orgId/voice-configuration/:id',
  type: VoiceConfiguration,
  observerCreator: ({ actions }) => {
    return ({ dispatch }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
        },
        onReplaceSuccess(item) {
          if (item) {
            dispatch(actions.broadcast(item));
          }
        },
        onAddSuccess(item) {
          if (item) {
            dispatch(actions.broadcast(item));
          }
        },
      };
    };
  },
});

export class VoiceConfigurationWithRequiredIvr extends VoiceConfiguration {
  @ValidateIf(props => !props.queueIvrId)
  @IsNotEmpty()
  initialIvrId?: string;

  @ValidateIf(props => !props.initialIvrId)
  @IsNotEmpty()
  queueIvrId?: string;
}

const normalizeError = errors => {
  const shouldSelectIvr = errors.filter(({ attr }) => attr === 'queueIvrId' || attr === 'initialIvrId').length === 2;
  if (!shouldSelectIvr) {
    return errors;
  }
  return errors.map(err => ({ ...err, detail: '', emptyIvrs: true }));
};

const validateWithRequiredOneIvr: sharedTypes.AppThunk = (attrs: any) => dispatch => {
  try {
    validateType(VoiceConfigurationWithRequiredIvr, attrs);
  } catch (err) {
    const translatedErrors = translateErrors((err as DomainError).errors);
    dispatch(validationError(normalizeError(translatedErrors)));
    return false;
  }
  return true;
};

voiceConfigurationResource.effects.validateWithRequiredOneIvr = validateWithRequiredOneIvr;
const { validationError } = voiceConfigurationResource.actions;

export default voiceConfigurationResource;
